import React from "react";
import MandatoryLabel from "../../components/common/label";
import { EditProfileLoader } from "../../components/common/loader";
import { InputErrorMessage } from "../../components/errorMessages";
import FPHeader from "./FPHeader";
import { commonUsedClass } from "../Account/MobileLoginTalwind";

export default function FPPage_1({ formik, loader, setLoader, BacktoSignin}) {
    const handleChange = (e) => {
        e.preventDefault();
        formik.handleChange(e);
    };
    return (
        <div>
            <FPHeader 
              Title={'Forgot password'}
              TitleDescription={'Enter your email for the verification process, we will send 4 digits code to your email.'}
              BacktoSignin={()=>{BacktoSignin()}}
            />
            <form className="forgotPassword" onSubmit={formik.handleSubmit} >
                <div className={commonUsedClass.inpcon} >
                    <div>
                        <MandatoryLabel title="Email" />
                        <input
                            type="email"
                            name="email"
                            className={
                                Boolean(formik.touched.email) && Boolean(formik.errors.email)
                                    ? commonUsedClass.inpNormal
                                    : commonUsedClass.inpErr
                            }
                            id="emailll"
                            placeholder="Email"
                            value={formik.values.email}
                            onChange={handleChange}
                        />
                        {
                            (formik.touched.email && formik.errors.email) &&
                            <InputErrorMessage
                                error={formik.touched.email && formik.errors.email}
                            />
                        }

                    </div>
                </div>
                <div className="mt-[15px]" >
                        <button
                            className={commonUsedClass.btncon}
                            type="submit"
                        >
                            {!loader ? (
                                'Continue'
                            ) : (
                                <div className="text-xs" >
                                    <EditProfileLoader />
                                </div>
                            )}
                        </button>
                </div>
            </form>
        </div>
    )
}